import { render, staticRenderFns } from "./HeaderAlarm.vue?vue&type=template&id=37f50752&scoped=true"
import script from "./HeaderAlarm.vue?vue&type=script&lang=js"
export * from "./HeaderAlarm.vue?vue&type=script&lang=js"
import style0 from "./HeaderAlarm.vue?vue&type=style&index=0&id=37f50752&prod&lang=css"
import style1 from "./HeaderAlarm.vue?vue&type=style&index=1&id=37f50752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f50752",
  null
  
)

export default component.exports